import React from "react";
import {
  formatMoney,
  formatTotal,
} from "../../../../../../utils/generalFormat";
import { ValueCard } from "../../../../billingPanel/components/totals/styles";
import { TotalsData } from "../../types";

export const Totals: React.FC<{ data: TotalsData }> = ({ data }) => {
  return (
    <>
      <ValueCard>
        <div>
          <p style={{ fontWeight: "bolder" }}>Valor Líquido:</p>
          <p>{formatTotal(data.totalLiquid)}</p>
        </div>

        <div>
          <p style={{ fontWeight: "bolder" }}>Valor Bruto:</p>
          <p>{formatTotal(data.totalGrossValue)}</p>
        </div>
      </ValueCard>
    </>
  );
};
